"use client"
import { useTheme } from "@/app/theme-provider";
import useFetch from "@/app/useFetch";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function VigilanceNav() {
      const {
        theme,
        toggleTheme,
        toggleHighlightLinks,
        highlightLinks,
        language,
        toggleLanguage,
      } = useTheme();
    const pathname = usePathname();

      const { data: awards } = useFetch(
        "/website/vigilance-awards-all",
        // { page, limit: 5 }, // pass page & limit here
        []
      );

    

    return (
        <>
            <div className="tabs-container mt-40">
                <ul className="custom-tabs nav">
                   
                    <li>
                        <Link href={`/vigilance/awards/${awards[0]?.permalink}`} className="nav-link">
                           {language=="en"?" Awards":"അവാർഡുകൾ"}
                        </Link>
                    </li>
                    <li>
                        <Link href="/vigilance/who-is-who" className={`${pathname==="/vigilance/who-is-who"?"active":""} nav-link`}>
                          {language=="en"?"Who is Who":" യൂണിറ്റ് മേധാവികള്‍"}  
                        </Link>
                    </li>
                    <li>
                        <Link href="/vigilance/former-chiefs" className={`${pathname==="/vigilance/former-chiefs"?"active":""} nav-link`}>
                           {language=="en"?" Former Chiefs":"മുൻ മേധാവികൾ"}
                        </Link>
                    </li>
                </ul>
            </div>
        </>

    );
}
